<div class="conversation-starter-card" (click)="conversationStarterSelected()">
    <div class="card-content" >
        <h6 class="starter-text line-clamp">{{ conversationStarters[0] }}</h6>
    </div>
</div>